module.exports = __webpack_public_path__ + "img/Abfahrk_Fahrzeugkontrolle.3884e4db.svg";